export default "__VITE_ASSET__BqWfUc4z__"